/**
 * Id do usuário logado a partir do access token (o backend assina `{ id }` em utils/token.js).
 * Só decodifica o payload, sem verificar a assinatura: serve para rotular "por você" no
 * histórico, nunca para autorizar nada.
 */
export function tokenUserId(token) {
    const part = typeof token === "string" ? token.split(".")[1] : null;
    if (!part) return null;
    try {
        const b64 = part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "=");
        const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
        const payload = JSON.parse(new TextDecoder().decode(bytes));
        return payload && payload.id ? String(payload.id) : null;
    } catch (_) {
        return null;
    }
}
